<template>
  <div>
    <Print></Print>
  </div>
</template>

<script>
import Print from "@/components/Print";
export default {
  name: "index",
  components: {
    Print
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>